import {HTTP} from '@/CallAPI'

export const reportCorrective = (params) => HTTP.post('checklists/reports/corrective', params)



// WEBPACK FOOTER //
// ./src/service/chk-report.js